<template>
  <v-container>
    <v-card align="justify">
      <v-card-title class="headline primary white--text">
        Intrare
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-flex xs12>
            <v-img
                class="centrado ml-4 mr-4 mt-3 mb-3"
                :src="require('../../assets/residencial_mx.png')"
                height="250px"
                contain
            ></v-img>
          </v-flex>
        </v-row>
        <br>
        <div><h2>Términos y Condiciones</h2></div>
        <br>
        <div class="body-2">
          El presente documento establece las condiciones mediante las cuales se regirá el uso del
          sistema y/o aplicación: INTRARE (en adelante el sistema), el cual es operado por
          TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. empresa constituida en
          México y domiciliada en la ciudad de San Luis Potosí, S.L.P. y que en adelante se
          identificara por su nombre comercial “INTRARE”
        </div>
        <br>
        <div class="body-2">
          INTRARE es un sistema digital de acceso que facilita la identificación y agiliza el proceso
          de ingreso de visitantes, proveedores, empleados y trabajadores domésticos a diversos
          polígonos, dejando un registro de fecha y hora de salida.
        </div>
        <br>
        <div class="body-2">
          INTRARE cuenta con submarcas que a su vez encuadran áreas específicas en las que se
          aplicaran los servicios del sistema, por lo que el usuario podrá encontrarse con las
          siguientes denominaciones dentro del sistema: a) Intrare Residencia, b)Intrare Empresa,
          c)Intrare Construcción, d)Intrare Escuela.
        </div>
        <br>
        <div class="body-2">
          El usuario se compromete a leer los términos y condiciones aquí establecidas, previamente
          al uso del sistema, por tanto, en caso de realizar la instalación se entiende que cuenta con
          el conocimiento integral de este documento y la consecuente aceptación de la totalidad de
          sus estipulaciones.
        </div>
        <br>
        <div class="body-2">
          El Usuario reconoce que el ingreso de su información personal y los datos que contiene el
          sistema a su disposición lo realizan de manera voluntaria, quienes optan por acceder a este
          sistema en México o desde fuera del territorio nacional, lo hacen por iniciativa propia y son
          responsables del cumplimiento de las leyes locales, en la medida en que dichas leyes sean
          aplicables en su correspondiente país. En caso de que se acceda por parte de menores de
          edad, deben contar con la supervisión de un adulto en todo momento desde la instalación
          y durante el uso del sistema, en el evento en que no se cumpla esta condición, le
          agradecemos no hacer uso del sistema.
        </div>
        <br>
        <div class="subtitle-1"><strong>Alcance y Uso</strong></div>
        <br>
        <div class="body-2">
          El usuario del sistema entiende y acepta que es operado por TECNOLOGÍAS EN
          ACCESOS CONTROLADOS SA DE CV., la información contenida en el mismo será la
          referente a su vínculo comercial o contractual con la empresa.
        </div>
        <br>
        <div class="body-2">
          Los tiempos de respuesta, tramites y demás solicitudes efectuadas por el usuario mediante
          el sistema serán procesadas de conformidad con las especificaciones de cada producto
          activo con INTRARE.
        </div>
        <br>
        <div class="body-2">
          El usuario acepta y autoriza que los registros electrónicos de las actividades mencionadas,
          que realice en el sistema constituyen plena prueba de los mismos.
        </div>
        <br>
        <div class="subtitle-1"><strong>Requisitos para Uso</strong></div>
        <br>
        <div class="body-2">
          El usuario deberá contar con un dispositivo móvil inteligente (Smartphone) o Tableta con
          sistema operativo Android o IOS o un ordenador, cualquiera de estos con acceso a internet,
          ambos seguros y confiables. INTRARE, no será responsable por la seguridad de los
          equipos Smartphone propiedad de los usuarios utilizados para el acceso al sistema, ni por
          la disponibilidad del servicio en los dispositivos en los cuales se descargue el sistema.
        </div>
        <br>
        <div class="body-2">
          En la forma permitida por la ley, los materiales del sistema se suministran sin garantía de
          ningún género, expresa o implícitamente, incluyendo sin limitación las garantías de calidad
          satisfactoria, comerciabilidad, adecuación para un fin particular o no infracción, por tanto,
          INTRARE no garantiza el funcionamiento adecuado en los distintos sistemas operativos o
          dispositivos en los cuales se haga uso del sistema.
        </div>
        <br>
        <div class="body-2">
          Para acceder al portal, EL CLIENTE contará con Usuario y Clave, que lo identifica en su
          relación con INTRARE. Adicional a lo anterior se requerirá a EL CLIENTE, al momento de
          acceder al sistema que ingrese su nombre de usuario y contraseña.
        </div>
        <br>
        <div class="subtitle-1"><strong>Obligaciones de los Usuarios</strong></div>
        <br>
        <div class="body-2">
          El Usuario se obliga a usar el sistema y los contenidos encontrados en ella de una manera
          diligente, correcta, lícita y en especial, se compromete a NO realizar las conductas descritas
          a continuación:
        </div>
        <br>
        <div class="body-2">
          (a) Utilizar los contenidos de forma, con fines o efectos contrarios a la ley, a la moral y a las
          buenas costumbres generalmente aceptadas o al orden público;
        </div>
        <br>
        <div class="body-2">
          (b) Reproducir, copiar, representar, utilizar, distribuir, transformar o modificar los contenidos
          del sistema, por cualquier procedimiento o sobre cualquier soporte, total o parcial, o permitir
          el acceso del público a través de cualquier modalidad de comunicación pública;
        </div>
        <br>
        <div class="body-2">
          (c) Utilizar los contenidos de cualquier manera que entrañen un riesgo de daño o
          inutilización del sistema o de los contenidos o de terceros;
        </div>
        <br>
        <div class="body-2">
          (d) Suprimir, eludir o manipular el derecho de autor y demás datos identificativos de los
          derechos de autor incorporados a los contenidos, así como los dispositivos técnicos de
          protección, o cualesquiera mecanismos de información que pudieren tener los contenidos;
        </div>
        <br>
        <div class="body-2">
          (e) Emplear los contenidos y, en particular, la información de cualquier clase obtenida a
          través de del sistema para distribuir, transmitir, remitir, modificar, rehusar o reportar la
          publicidad o los contenidos de esta con fines de venta directa o con cualquier otra clase de
          finalidad comercial, mensajes no solicitados dirigidos a una pluralidad de personas con
          independencia de su finalidad, así como comercializar o divulgar de cualquier modo dicha
          información;
        </div>
        <br>
        <div class="body-2">
          (f) No permitir que terceros ajenos a usted usen el sistema con su clave;
        </div>
        <br>
        <div class="body-2">
          (g) Utilizar el sistema y los contenidos con fines lícitos y/o ilícitos, contrarios a lo establecido
          en estos Términos y Condiciones, o al uso mismo del sistema, que sean lesivos de los
          derechos e intereses de terceros, o que de cualquier forma puedan dañar, inutilizar,
          sobrecargar o deteriorar el sistema y los contenidos o impedir la normal utilización o disfrute
          de esta y de los contenidos por parte de los usuarios.
        </div>
        <br>
        <div class="subtitle-1"><strong>Propiedad Intelectual</strong></div>
        <br>
        <div class="body-2">
          Todo el material informático, gráfico, publicitario, fotográfico, de multimedia, audiovisual y
          de diseño, así como todos los contenidos, textos y bases de datos puestos a su disposición
          en este sistema están protegidos por derechos de autor y/o propiedad industrial cuyo titular
          es TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. Igualmente, el uso en el
          sistema de algunos materiales de propiedad de terceros se encuentra expresamente
          autorizado por la ley o por dichos terceros. Todos los contenidos en el sistema están
          protegidos por las normas sobre derecho de autor y por todas las normas nacionales e
          internacionales que le sean aplicables.
        </div>
        <br>
        <div class="body-2">
          Exceptuando lo expresamente estipulado en estos Términos y Condiciones, queda
          prohibido todo acto de copia, reproducción, modificación, creación de trabajos derivados,
          venta o distribución, exhibición de los contenidos de este sistema, de manera o por medio
          alguno, incluyendo, más no limitado a, medios electrónicos, mecánicos, de fotocopiado, de
          grabación o de cualquier otra índole, sin el permiso previo y por escrito de INTRARE o del
          titular de los respectivos derechos.
        </div>
        <br>
        <div class="body-2">
          En ningún caso estos Términos y Condiciones confieren derechos, licencias ni
          autorizaciones para realizar los actos anteriormente prohibidos. Cualquier uso no
          autorizado de los contenidos constituirá una violación del presente documento y a las
          normas vigentes sobre derechos de autor, a las normas vigentes nacionales e
          internacionales sobre Propiedad Industrial, y a cualquier otra que sea aplicable.
        </div>
        <br>
        <div class="subtitle-1"><strong>Licencia para Copiar para Uso Personal</strong></div>
        <br>
        <div class="body-2">
          Usted podrá leer, visualizar, imprimir y descargar el material que integra el sistema.
        </div>
        <br>
        <div class="body-2">
          Ninguna parte del sistema podrá ser reproducida o transmitida o almacenada en otro sitio
          web o en otra forma de sistema de recuperación electrónico.
        </div>
        <br>
        <div class="body-2">
          Ya sea que se reconozca específicamente o no, las marcas comerciales, las marcas de
          servicio y los logos visualizados en este sistema pertenecen a TECNOLOGÍAS EN
          ACCESOS CONTROLADOS S.A. DE C.V., sus socios promocionales u otros terceros.
        </div>
        <br>
        <div class="body-2">
          INTRARE no interfiere, no toma decisiones, ni garantiza las relaciones que los usuarios
          lleguen a sostener o las vinculaciones con terceros que pauten y/o promocionen sus
          productos y servicios. Estas marcas de terceros se utilizan solamente para identificar los
          productos y servicios de sus respectivos propietarios y el patrocinio o el aval por parte de
          INTRARE no se deben inferir con el uso de estas marcas comerciales.
        </div>
        <br>
        <div class="subtitle-1"><strong>Integración con Otras Aplicaciones</strong></div>
        <br>
        <div class="body-2">
          INTRARE podrá enlazarse por medio de links con otras aplicaciones como por ejemplo
          Facebook, Google, Gmail, One Drive , etc. Lo anterior con el fin de poder sincronizar
          calendarios y wallets.
        </div>
        <br>
        <div class="body-2">
          INTRARE trata de suministrar enlaces a sitios y aplicaciones de terceros que cumplan con
          las leyes y regulaciones aplicables y las normas de INTRARE, el Usuario debe entender
          que INTRARE no tiene control sobre la naturaleza y el contenido de esos sitios y no está
          recomendando estos sitios, la información que contienen ni los productos o servicios de
          terceros.
        </div>
        <br>
        <div class="body-2">
          INTRARE no acepta responsabilidad por el contenido del sitio de un tercero con el cual
          existe un link de hipertexto y no ofrece garantía (explícita o implícita) en cuanto al contenido
          de la información en esos sitios, ya que no recomienda estos sitios.
        </div>
        <br>
        <div class="body-2">
          Usted debe verificar las secciones de términos y condiciones, política legal y de privacidad
          de algunos otros sitios que con los cuales INTRARE se enlaza.
        </div>
        <br>
        <div class="body-2">
          INTRARE no asume ninguna responsabilidad por pérdida directa, indirecta o consecuencial
          por el uso de un sitio de un tercero.
        </div>
        <br>
        <div class="subtitle-1"><strong>POLÍTICAS DE PRIVACIDAD Y USO DE DATOS PERSONALES DE LOS USUARIOS.</strong></div>
        <br>
        <div class="body-2">
          Para la debida operación del sistema, TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. a través de INTRARE, recabará datos de los usuarios, los cuales pueden llegar a ser de carácter sensible dependiendo de su naturaleza.
        </div>
        <br>
        <div class="body-2">
          <strong>Datos que se recaban</strong><br>INTRARE podrá recabar alguno o todos de los siguientes datos:
        </div>
        <br>
        <div class="body-2">
          <ul>
            <li>Datos personales: Nombres, Apellidos, CURP, imágenes de Identificación Oficial (INE) ambas caras, comprobante de domicilio, ID de usuario.</li>
            <li>Datos de contacto: Correo electrónico, Número de teléfono móvil, Domicilio.</li>
            <li>Datos Empresariales: Razón Social, RFC, Información General de la empresa, Constancia de SUA, Constancia de Situación Fiscal.</li>
            <li>Datos de dispositivos para acceso a la aplicación móvil: Marca, Modelo, Sistema Operativo, Ubicación.</li>
            <li>Datos de calendario: Fechas y Notas.</li>
          </ul>
        </div>
        <br>
        <div class="body-2">
          <strong>Finalidad de la recabación de datos</strong><br>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. usará los datos recabados del usuario para poder llevar a cabo las siguientes finalidades:
        </div>
        <br>
        <div class="body-2">
          <ul>
            <li>Acceso del usuario al sistema y a la aplicación.</li>
            <li>Creación de una cuenta.</li>
            <li>Generar invitaciones en el sistema para visitantes.</li>
            <li>Dar acceso remoto a invitados.</li>
            <li>Identificación de cada usuario del sistema, necesario para una prestación de Servicios Personalizada acorde a las necesidades particulares de cada cliente.</li>
            <li>Creación de un expediente virtual interno de cada cliente.</li>
            <li>Obtener información complementaria con el propósito de que los servicios del sistema puedan cumplir satisfactoriamente.</li>
            <li>Interacción entre administradores del sistema, usuarios y visitantes.</li>
            <li>Mantener el registro de entradas y salidas por medio del sistema.</li>
            <li>Poder consultar bases de datos.</li>
            <li>Registro de la actividad del usuario en el sistema o en la aplicación móvil.</li>
            <li>Informe de errores o fallas de la aplicación.</li>
            <li>Integración con otras aplicaciones o sistemas con los que trabaja INTRARE.</li>
          </ul>
        </div>
        <br>
        <div class="body-2">
          <strong>La aplicación móvil podrá solicitar los siguientes permisos en su dispositivo</strong><br>
          <ul>
            <li>Permiso para acceder a la ubicación exacta del dispositivo.</li>
            <li>Permiso para acceder a la lista de contactos del dispositivo.</li>
            <li>Permiso para acceder a la cámara y galería del dispositivo.</li>
            <li>Permiso para acceder al control del micrófono.</li>
          </ul>
        </div>
        <br>
        <div class="body-2">
          <strong>Transmisión de datos a terceros</strong><br><br>
          TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. podrá transmitir los datos recabados del usuario a terceros, únicamente para poder cumplir con las finalidades descritas anteriormente y para el correcto funcionamiento del sistema y la aplicación móvil.<br>
          En ningún momento TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.  transmitirá los datos del usuario con fines distintos a los ya antes señalados y así mismo garantizará que los receptores de los datos transmitidos cumplan con todas las políticas aplicables a la privacidad del usuario.
        </div>
        <br>
        <div class="body-2">
          <strong>NÚMEROS DE TELÉFONOS Y CONTACTOS</strong><br><br>
          Una vez que el usuario otorgue el acceso a INTRARE a su lista de contactos (Nombres /Números de Teléfono) almacenados en su dispositivo móvil, INTRARE NO realizará copia alguna de los contactos almacenados.<br>
          Los datos del contacto solo se utilizan cuando el usuario desea crear una invitación. INTRARE seleccionará el contacto que el Usuario esté buscando y autocompletará los campos de teléfono y nombre con los datos de contacto de este, creando la invitación correspondiente.  Con estos datos se puede identificar al invitado; el número de teléfono se usa para poder notificar al invitado y el nombre para identificarlo al momento del acceso.<br>
          Una vez creada la invitación y notificado el invitado, INTRARE desecha la información del contacto, por lo que no almacena información alguna en sus servidores.<br>
          INTRARE, en ningún momento utilizará los datos de contacto para cualquier otro objetivo que no sea crear una invitación y notificarle la misma. TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. y/o INTRARE por NINGÚN MOTIVO utilizará la información del contacto para ofrecer servicios, enviar anuncios, enviar correos o cualquier otro tipo de publicidad.<br>
          INTRARE no realiza copias de la lista de contactos del usuario y tampoco los transmite a terceros.<br>
          El usuario en todo momento podrá retirar el permiso de acceder a sus contactos a INTRARE, esto por medio de su dispositivo móvil, accediendo a la configuración de la aplicación y entrando a la sección de permisos. Esto limitará algunas funciones de la aplicación móvil.
        </div>
        <br>
        <div class="body-2">
          <strong>POLÍTICAS DE USO IMAGEN PERSONAL DEL USUARIO Y VISITANTES</strong><br><br>
          INTRARE solo solicitará al usuario y a los visitantes su imagen con el fin de poder identificarlos y que se pueda cumplir con los servicios de la aplicación. INTRARE en ningún momento utilizará o divulgará la imagen del usuario y/o los invitados fuera de la aplicación móvil y/o su sistema.<br><br>
          Así mismo INTRARE por ningún motivo transmitirá a terceros la imagen del usuario y/o de los invitados, con fines diferentes al debido funcionamiento de la aplicación móvil.<br><br>
          INTRARE solo almacenará de forma permanente en sus servidores las imágenes de los Usuarios.<br><br>
          INTRARE almacenará de forma provisional las imágenes de los visitantes, con el fin de poder generar la invitación correspondiente, una vez que esta cumpla con su objetivo, se eliminará automáticamente, junto con la información del visitante.<br><br>
        </div>
        <br>
        <div class="subtitle-1"><strong>Responsabilidad de INTRARE</strong></div>
        <br>
        <div class="body-2">
          INTRARE procurará garantizar disponibilidad, continuidad o buen funcionamiento del
          sistema. INTRARE podrá bloquear, interrumpir o restringir el acceso a esta cuando lo
          considere necesario para el mejoramiento del sistema o por dada de baja de la misma.
        </div>
        <br>
        <div class="body-2">
          Se recomienda al Usuario tomar medidas adecuadas y actuar diligentemente al momento
          de acceder al sistema, como, por ejemplo, contar con programas de protección, antivirus,
          para manejo de malware, spyware y herramientas similares.
        </div>
        <br>
        <div class="body-2">
          INTRARE no será responsable por: a) Fuerza mayor o caso fortuito; b) Por la pérdida,
          extravío o hurto de su dispositivo móvil u ordenador que implique el acceso de terceros a al
          sistema; c) Por errores en la digitación o accesos por parte del cliente; d) Por los perjuicios,
          lucro cesante, daño emergente, morales, y en general sumas a cargo de INTRARE,
          derivados de los retrasos, no procesamiento de información o suspensión del servicio del
          operador móvil o daños en los dispositivos móviles.
        </div>
        <br>
        <div class="subtitle-1"><strong>Pagos</strong></div>
        <br>
        <div class="body-2">
          INTRARE no recibe ni gestiona pagos por medio del sistema. Todo lo relacionado a
          contratación y pagos se maneja de forma externa entre TECNOLOGÍAS EN ACCESOS
          CONTROLADOS S.A. DE C.V. y el Cliente por otros medios.
        </div>
        <br>
        <div class="subtitle-1"><strong>Denegación y Retirada del Acceso al Sistema</strong></div>
        <br>
        <div class="body-2">
          En el Evento en que un Usuario incumpla estos Términos y Condiciones, o cualesquiera
          otras disposiciones que resulten de aplicación, INTRARE podrá suspender su acceso al
          sistema.
        </div>
        <br>
        <div class="subtitle-1"><strong>Términos y Condiciones</strong></div>
        <br>
        <div class="body-2">
          El Usuario acepta expresamente los Términos y Condiciones, siendo condición esencial
          para la utilización de este sistema. En el caso en que se encuentre en desacuerdo con estos
          Términos y Condiciones, solicitamos abandonar el sistema inmediatamente. INTRARE
          podrá modificar los presentes términos y condiciones, avisando a los usuarios del sistema
          mediante publicación en la página web www.intrare.com.mx o mediante la difusión de las
          modificaciones por algún medio electrónico, redes sociales, SMS y/o correo electrónico, lo
          cual se entenderá aceptado por el usuario si éste continua con el uso del sistema.
        </div>
        <br>
        <div class="subtitle-1"><strong>Uso de Información no Personal</strong></div>
        <br>
        <div class="body-2">
          INTRARE también recolecta información no personal en forma agregada para seguimiento
          de datos como el número total de accesos al sistema, instalación, descarga, etc. Utilizamos
          esta información, que permanece en forma agregada, para entender el comportamiento del
          sistema y poder mejorar el servicio del mismo.
        </div>
        <br>
        <div class="subtitle-1"><strong>Uso de Direcciones IP</strong></div>
        <br>
        <div class="body-2">
          Una dirección de Protocolo de Internet (IP) es un conjunto de números que se asigna
          automáticamente a su o dispositivo móvil u ordenador cuando usted accede a su proveedor
          de servicios de internet, o a través de la red de área local (LAN) de su organización o la red
          de área amplia (WAN). Los servidores web automáticamente identifican su dispositivo móvil
          u ordenador por la dirección IP asignada a él durante su sesión en línea.
        </div>
        <br>
        <div class="body-2">
          INTRARE podrán recolectar direcciones IP para propósitos de administración de sistemas
          y para auditar el uso de nuestro sistema, todo lo anterior de acuerdo con la autorización de
          protección de datos que se suscribe para tal efecto. Normalmente no vinculamos la
          dirección IP de un usuario con la información personal de ese usuario, lo que significa que
          cada sesión de usuario se registra, pero el usuario sigue siendo anónimo para nosotros.
          Sin embargo, podemos usar las direcciones IP para identificar a los usuarios de nuestro
          sistema cuando sea necesario con el objeto de exigir el cumplimiento de los términos de
          uso del sistema, o para proteger nuestro servicio, sitio u otros usuarios.
        </div>
        <br>
        <div class="subtitle-1"><strong>Seguridad y Protección de datos</strong></div>
        <br>
        <div class="body-2">
          INTRARE está comprometido en la protección de la seguridad de su información personal. INTRARE tiene implementados mecanismos de seguridad que aseguran la protección de la información personal, así como los accesos únicamente al personal y sistemas autorizados, también contra la pérdida, uso indebido y alteración de sus datos de usuario bajo nuestro control.
        </div>
        <br>
        <div class="body-2">
          Como se indica a continuación, sólo personal autorizado tiene acceso a la información que nos proporciona. Además, hemos impuesto reglas estrictas a los empleados de INTRARE con acceso a las bases de datos que almacenan información del usuario o a los servidores que hospedan nuestros servicios, respaldadas por contratos de confidencialidad y cartas responsivas.
        </div>
        <br>
        <div class="body-2">
          TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.  por ningún motivo Comercializará sus datos con terceros.
        </div>
        <br>
        <div class="body-2">
          <strong>Autorización y consentimiento para el uso de datos</strong><br><br>
          Al ingresar al sistema o descargar la aplicación móvil usted deberá de aceptar y autorizar de forma expresa que TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V., utilice sus datos. Quedando este en calidad de responsable del tratamiento para fines derivados de la ejecución del sistema o aplicación móvil. TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. informa que el usuario podrá ejercer sus derechos a conocer, actualizar, rectificar y suprimir su información personal; así como el derecho a revocar el consentimiento otorgado para el tratamiento de datos personales previstos en la ley, observando nuestro <a href="https://test-club.intrare.app/notice_privacy">Aviso de Privacidad</a> mismo que se establece en nuestra página www.intrare.com.mx ; o a través de <a href="mailto:hola@intrare.app">hola@intrare.app</a>.
        </div>
        <br>
        <div class="body-2">
          <strong>Revocación, Limitación y Rectificación</strong><br><br>
          El Usuario en todo momento podrá revocar el uso de sus datos personales, por medio del aviso por escrito dirigido a TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V., teniendo conocimiento que esto afectará el funcionamiento del sistema y/o la aplicación móvil.<br>
          El Usuario en todo momento podrá limitar el uso de sus datos personales, por medio del aviso por escrito dirigido a TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V., teniendo conocimiento que esto puede afectar el debido funcionamiento del sistema y/o la aplicación móvil.<br>
          El Usuario en todo momento podrá rectificar sus datos personales, por medio del aviso por escrito dirigido a TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.<br>
          Para cualquiera de estos casos el usuario deberá de enviar la solicitud dirigida a TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.
        </div>
        <br>
         <div class="subtitle-1"><strong>Jurisdicción</strong></div>
        <br>
        <div class="body-2">
          Estos términos y condiciones y todo lo que tenga que ver con este sistema, se rigen por las leyes Mexicanas y los Tratados Internacionales de los que forma parte México. Para cualquier solución de conflictos que pudieran resultar del uso del sistema, las partes se someten a la jurisdicción de los tribunales de la Ciudad de San Luis Potosí, S.L.P., renunciando a cualquiera otra que por domicilio les corresponda.
        </div>
        <br>
        <div class="body-2">
          TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.<br>
          <a href="mailto:hola@intrare.app">hola@intrare.app</a><br>
          <a href="https://www.intrare.com.mx">https://www.intrare.com.mx</a>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'terms_conditions'
}
</script>

<style scoped>

</style>
